import { Grid } from "@mui/material";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import DateService from "../../../services/dateService";
import FloatField from "../../base/FloatField/FloatField";
import AutocompleteField from "../../field/AutocompleteField";
import DateField from "../../field/DateField/DateField";
import SelectField from "../../field/SelectField";
import TextFieldFormControl from "../../field/TextFieldFormControl/TextFieldFormControl";

const ExampleForm = (props) => {
    const { t } = useTranslation();

    return (
        <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-start"
            rowGap={1}
        >
            <Grid item xs={12}>
                <AutocompleteField
                    name={"autocomplete_val"}
                    label={t("form.example_form.autocomplete_val")}
                    value={props.data?.autocomplete_val}
                    options={props.autoCompleteOptions}
                    isObjectOption={true}
                    optionLabelKey={"option_label_key"}
                    onChange={props.onChangeAutocomplete}
                    addNewValue={false}
                    multiple={false}
                />
            </Grid>
            <Grid item xs={12}>
                <TextFieldFormControl
                    name="text_field_val"
                    value={props.data?.text_field_val}
                    label={t("form.example_form.text_field_val")}
                    onChange={props.onChange}
                />
            </Grid>
            <Grid item xs={12}>
                <FloatField
                    name="float_field_val"
                    value={props.data?.float_field_val}
                    label={t("form.example_form.float_field_val")}
                    onChange={props.onChange}
                />
            </Grid>

            <Grid item xs={12}>
                <DateField
                    name="date_field_val"
                    label={t("form.example_form.date_field_val")}
                    value={DateService.convertDateToFormatYYYYMMDD(props.data?.date_field_val)}
                    onChange={props.onChange}
                    readOnly={props.readOnly}
                />
            </Grid>
            <Grid item xs={12}>
                <SelectField
                    label={t("form.example_form.select_field_val")}
                    name="select_field_val"
                    value={props.data?.select_field_val}
                    options={props.selectFieldOptions}
                    isObjectOption={false}
                    onChange={props.onChange}
                    readOnly={props.readOnly}
                />
            </Grid>
        </Grid>
    );
};

ExampleForm.propTypes = {
    data: PropTypes.object,
    onChange: PropTypes.func,
    onChangeDate: PropTypes.func,
    onChangeAutocomplete: PropTypes.func,
    readOnly: PropTypes.bool,
    selectFieldOptions: PropTypes.array,
    autoCompleteOptions: PropTypes.array, // array of dicts  like {id : "",  "option_label_key" : ""}
};

ExampleForm.defaultProps = {
    readOnly: false,
    selectFieldOptions: [],
};

export default ExampleForm;
